import React from 'react'

// material ui
import Box from '@mui/material/Box'

// components
import AccountButton from 'components/atoms/AccountButton'

// styling
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

export default function PreferencesFormButton(props) {
  const { loading, preferences, form, onClickUpdate } = props

  // display full width button on mobile
  const theme = useTheme()
  const fullWidth = useMediaQuery(theme.breakpoints.down('sm'))

  // returns true if form state differs from account preferences
  const formChanged = () =>
    ['newProjectNotifications', 'onlineOnly'].every(
      attr => String(preferences[attr]) === String(form[attr])
    )

  const formDisabled = loading || formChanged()

  return (
    <Box mt={2}>
      <AccountButton
        fullWidth={fullWidth}
        onClick={onClickUpdate}
        disabled={formDisabled}
        variant='contained'
        color='secondary'
      >
        {loading ? 'Updating...' : 'Update'}
      </AccountButton>
    </Box>
  )
}
